import { render, staticRenderFns } from "./CloseCase.vue?vue&type=template&id=5094546c&scoped=true"
import script from "./CloseCase.vue?vue&type=script&lang=js"
export * from "./CloseCase.vue?vue&type=script&lang=js"
import style0 from "./CloseCase.vue?vue&type=style&index=0&id=5094546c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094546c",
  null
  
)

export default component.exports